<div>
  <div class="flex justify-content-between align-items-center flex-wrap mb-4 mt-4">
    <div class="text-800 text-2xl font-medium">{{ paragraphTitle }}</div>
  </div>
  <div [innerHTML]="paragraph1Content" class="mb-4"></div>
  <div *ngIf="showAdviceBulletpoints">
    <div class="flex align-items-center my-4">
      <div><img src="assets/svg/sun.svg" height="40px" alt="Sun" /></div>
      <div class="ml-2">{{ 'ENCOURAGE_OUTDOOR_TIMES' | translate }}</div>
    </div>
    <div class="flex align-items-center my-4">
      <div><img src="assets/svg/book.svg" height="40px" alt="Sun" /></div>
      <div><img src="assets/svg/mobile-app.svg" height="40px" alt="Sun" /></div>

      <div class="ml-2">{{ 'BALANCING_NEAR_ACTIVITIES' | translate }}</div>
    </div>
    <div class="flex align-items-center my-4 gap-2">
      <div><img src="assets/svg/eye-test.svg" height="40px" alt="Sun" /></div>
      <div class="ml-2">{{ 'REGULAR_EYE_EXAMS' | translate }}</div>
    </div>

    <div *ngIf="showTreatmentInBulletPoints" class="flex align-items-center my-4">
      <div class=""><img src="assets/svg/glasses.svg" height="40px" alt="Sun" /></div>
      <div class=""><img src="assets/svg/contact-lens.svg" height="40px" alt="Sun" /></div>
      <div class="ml-2">{{ 'MYOPIA_MANAGEMENT_TREATMENT' | translate }}</div>
    </div>
  </div>
</div>